import gql from 'graphql-tag';

export const TRAINING_FORM = gql`
  query ($id: ID!) {
    training(id: $id) {
      from
      to
      presentTrainingIndicator
      country
      organisationName
      programmeName
      supportingDocuments {
        id
        link
        name
      }
    }
  }
`;
